import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {AnalyseStarterService} from '../analyse-starter.service';
import {DataStorageService} from '../data-storage.service';

@Injectable({
  providedIn: 'root'
})
export class DirectModuleSelectionService {
  isDirect$: Observable<boolean>;

  private readonly isDirectSubject: BehaviorSubject<boolean>;
  private readonly directModeStorageKey = 'isDirectMode';

  constructor(
    private readonly storage: DataStorageService,
    private readonly starter: AnalyseStarterService
  ) {
    const initialValue = this.storage.get(
      this.directModeStorageKey,
      sessionStorage
    );
    this.isDirectSubject = new BehaviorSubject<boolean>(initialValue === true);
    this.isDirect$ = this.isDirectSubject.asObservable();
  }

  public enableDirectMode(module: 'm1' | 'm2') {
    this.storage.store(this.directModeStorageKey, true, sessionStorage);
    this.isDirectSubject.next(true);
    this.starter.setFlagsAndStartAnalysis(module === 'm2');
  }
}
